import { useState } from 'react';

import { ReactComponent as ArrowIcon } from '@assets/img/icons/arrow-down-class.svg';
import classNames from 'classnames';

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

import { NibCardItem as CardItem } from '../NibCard';

const InputDropDown = ({
  disabled = false,
  label,
  formik,
  name,
  value = '',
  onChange = false,
  options = [],
  helperText,
  multiple = false,
  renderValue = false,
  tools = ['info'],
  ...props
}) => {
  const [isHelpShow, setHelp] = useState(false);

  const handleChange = (e) => {
    formik.handleChange(e);
    if (onChange) {
      onChange(e.target.value);
    }
  };

  const renderSelectValue = (value) => {
    if (value && renderValue) {
      return renderValue(multiple ? value : options.find((option) => option.id === value));
    } else if (value) {
      return getSelectedValue(value);
    } else if (props.placeholder) {
      return props.placeholder;
    } else {
      return 'Select';
    }
  };

  const getSelectedValue = (value) => {
    return options.find(function (option) {
      return option.id === value;
    })?.label;
  };

  return (
    <CardItem name={label} btns={tools} onInfo={() => setHelp(!isHelpShow)}>
      <FormControl size="small" style={{ width: '100%' }} variant="outlined">
        <InputLabel>{label}</InputLabel>
        <Select
          disabled={disabled}
          size="small"
          multiple={multiple}
          value={value || formik.values[name]}
          name={name}
          onChange={handleChange}
          onBlur={formik.handleBlur}
          label={label}
          displayEmpty
          error={formik.touched[name] && formik.errors[name]}
          IconComponent={() => <ArrowIcon />}
          renderValue={(value) => renderSelectValue(value)}
          className={classNames('entitySelect', (value || formik.values[name]) && 'entitySelectActive')}
        >
          {Array.isArray(options)
            ? options.map((item) => (
                <MenuItem key={`${name}-${item.id}`} value={item.value}>
                  {item.render ? item.render(item) : item.label}
                </MenuItem>
              ))
            : null}
        </Select>
        <FormHelperText>{isHelpShow && helperText}</FormHelperText>
        {formik.touched[name] && formik.errors[name] && <p className={'customErrorMsg'}>{formik.errors[name]}</p>}
      </FormControl>
    </CardItem>
  );
};

export default InputDropDown;
